import script from "./HouseSpecialities.vue?vue&type=script&setup=true&lang=js"
export * from "./HouseSpecialities.vue?vue&type=script&setup=true&lang=js"

import "./HouseSpecialities.vue?vue&type=style&index=0&id=c55cabcc&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c55cabcc"]])

export default __exports__